import { Icon, IconIdentifier } from '@aus-platform/design-system';
import classNames from 'classnames';
import React from 'react';

type SetupStepsProps = {
  className?: string;
};

type Step = {
  icon: IconIdentifier;
  title: string;
  description: string;
};

const steps: Step[] = [
  {
    icon: IconIdentifier.Mobile,
    title: 'Authenticator App',
    description:
      'Install an authenticator app such as Google Authenticator, Microsoft Authenticator, or Authy on your phone.',
  },
  {
    icon: IconIdentifier.QrCode,
    title: 'Scan the QR Code or Enter the Setup Key',
    description:
      'Use your authenticator app to scan the QR code or enter the setup key manually.',
  },
  {
    icon: IconIdentifier.Key,
    title: 'Save Backup Codes',
    description:
      'Save your backup codes in a secure location. These can be used if you lose access to your authenticator app.',
  },
];

export const SetupSteps: React.FC<SetupStepsProps> = ({ className }) => {
  // Variables.
  const customClassname = classNames('setup-steps', className);

  return (
    <div className={customClassname}>
      {steps.map(({ icon, title, description }) => (
        <div key={title} className="setup-steps__item">
          <div className="setup-steps__icon">
            <Icon identifier={icon} size={20} />
          </div>

          <div className="setup-steps__content">
            <div className="setup-steps__title">{title}</div>
            <div className="setup-steps__description">{description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
